<div class="min-h-screen bg-base-100 text-base-content p-4">
  <div class="max-w-2xl w-full bg-base-100 border border-base-300 rounded-lg shadow-xl p-8 mx-auto mt-16">
    <div class="text-center mb-8">
      <!-- Success Icon -->
      <div
        class="daisy-mask daisy-mask-circle bg-success text-success-content w-20 h-20 mx-auto mb-6 flex items-center justify-center"
      >
        <i class="fa-solid fa-check text-3xl"></i>
      </div>

      <h2 class="text-3xl font-bold text-success mb-4">Payment Successful!</h2>
      <p class="text-base-content/70 mb-8">
        Thank you for your payment. Your subscription will be automatically
        activated once payment is confirmed from our end. This process may take
        less than 2 working days.
      </p>
    </div>

    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <a
        [routerLink]="['/dashboard/user']"
        [fragment]="'subscriptions'"
        class="daisy-btn daisy-btn-outline"
      >
        <i class="fa-solid fa-list-check mr-2"></i>
        All Subscriptions
      </a>
      <a routerLink="/my-learnings" class="daisy-btn daisy-btn-primary">
        <i class="fa-solid fa-graduation-cap mr-2"></i>
        Continue Learning
      </a>
    </div>
  </div>
</div>
